import { Result } from 'antd';
const Error404 = () => (
    <Result
        status="404"
        title="404"
        subTitle="非常抱歉，您访问的页面不翼而飞了。"
    />
);
export default Error404;